<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-btn color="general" light class="mb-2" @click="newItem">{{
                  $t("language.new")
                }}</v-btn>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="grid.search"
                  append-icon="search"
                  :label="$t('language.search')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex> -->
            </v-layout>
          </v-container>
          <v-dialog v-model="dialog" max-width="600px">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-title>{{
                    $t("language.lateinearlyoutapplication")
                  }}</v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.type')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.type"
                              :items="LateInEarlyOutList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.type')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <ValidationProvider
                            :name="$t('language.date')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <eng-nep-date-picker
                              :error-messages="errors[0]"
                              v-model="vModel.date"
                              :label="$t('language.date')"
                            ></eng-nep-date-picker>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <ValidationProvider
                            :name="$t('language.approver')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.approvedbyid"
                              :items="ApproverList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.approver')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4
                          v-if="$store.getters.settings.enablerecommender"
                        >
                          <ValidationProvider
                            :name="$t('language.recommender')"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              dense
                              v-model="vModel.recommendedbyid"
                              :items="RecommenderList"
                              item-text="name"
                              item-value="id"
                              :label="$t('language.recommender')"
                              :error-messages="errors[0]"
                              :clearable="true"
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-flex>
                        <v-flex xs12 sm6 md8>
                          <ValidationProvider
                            :name="$t('language.remarks')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              dense
                              v-model="vModel.remarks"
                              :label="$t('language.remarks')"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      dense
                      color="grey darken-1"
                      text
                      @click="closedialog"
                      >{{ $t("language.cancel") }}</v-btn
                    >
                    <v-btn dense color="blue darken-1" text type="submit">{{
                      $t("language.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-dialog>

          <v-data-table
            :headers="grid.headers"
            :items="grid.body"
            :search="grid.search"
            :options.sync="grid.options"
            :server-items-length="grid.total"
            :loading="grid.loading"
            :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
            class="elevation-2"
          >
            <template v-slot:header.date>
              <span>{{ $t("language.date") }}</span>
            </template>
            <template v-slot:header.type>
              <span>{{ $t("language.type") }}</span>
            </template>
            <template v-slot:header.approver>
              <span>{{ $t("language.approver") }}</span>
            </template>
            <template v-slot:header.remarks>
              <span>{{ $t("language.remarks") }}</span>
            </template>
            <template v-slot:item.type="{ item }">
              {{ $t("language." + item.type.toLowerCase()) }}
            </template>
            <template v-slot:item.date="{ item }">
              {{getDefaultDate(item.date)}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small @click="deleteItem(item.id)">delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Base from "../../../shared/Base.vue";
import moment from "moment";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import commonservice from "../../../shared/common.service";
export default {
  name: "lateinearlyoutapplicationview",
  extends: Base,
  components: {
    EngNepDatePicker,
  },
  data() {
    return {
      LateInEarlyOutList: commonservice.LateInEarlyOutList,
      ApproverList: [],
      RecommenderList: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get("client/application/lateinearlyouts/init/list")
      .then((response) => {
        next((p) => {
          p.ApproverList = response.data.approvers;
          p.RecommenderList = response.data.recommenders;
        });
      });
  },
  created() {
    this.grid.headers = [
      { value: "date" },
      { value: "type" },
      { value: "approver" },
      { value: "remarks" },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      date: moment().format("YYYY-MM-DD"),
      todate: null,
      lateinearlyoutid: null,
      remarks: null,
      approvedbyid: null,
      recommendedbyid: null,
      place: null,
    };
    this.url = "client/application/lateinearlyouts";
  },
};
</script>
